<template>
  <div class="timer-wrapper" v-if="isTimerSet && showTimer && isSessionTimerActive">
    <div class="timer-wrapper-inactive" v-if="!isAnyTimeLeft">
      <div class="time-desc">
        <span class="time-text">{{ $t('header.sessionTimer.timeOut') }}</span>
      </div>
    </div>
    <div class="timer-wrapper-active" v-if="isAnyTimeLeft">
      <div class="time-desc">
        <span class="time-text">{{ $t('header.sessionTimer.sessionEnd') }}</span>
        <span class="time-counter">
          <span>{{ minutesLeft }}:{{ secondsLeft }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ROUTING } from '@/base/const/routing.const'

const SHOW_TIMER = Math.round(5 * 60 * 1000)

defineOptions({ name: 'SessionTimer' })

const store = useStore()
const router = useRouter()

let endTime = null
let timeoutHandler = null
const hoursLeft = ref(null)
const minutesLeft = ref(null)
const secondsLeft = ref(null)
const isTimerSet = ref(false)
const isAnyTimeLeft = ref(null)
const showTimer = ref(false)

const isSessionTimerActive = computed(() => store.state.payment.session.active)
const paymentData = computed(() => store.state.payment.paymentData)

watch(isSessionTimerActive, (newValue) => {
  if (newValue === false) {
    clearTimeout(timeoutHandler)
    isAnyTimeLeft.value = false
  }
})

function refresh() {
  store.dispatch('refreshSession').then((sessionRemainingTime) => {
    countdown(sessionRemainingTime)
  })
}

function countdown(seconds) {
  clearTimeout(timeoutHandler)
  endTime = +new Date() + seconds * 1000
  updateTimer()
}

function updateTimer() {
  const millisecondsLeft = endTime - +new Date()
  if (millisecondsLeft <= SHOW_TIMER) {
    if (!showTimer.value) {
      showTimer.value = true
    }
  } else {
    if (showTimer.value) {
      showTimer.value = false
    }
  }
  if (millisecondsLeft < 1000) {
    isAnyTimeLeft.value = false
    store
      .dispatch('rejectSession')
      .then(() => {
        store.commit('SET_PAYMENT_PAYWALL_VIEW', false)
        router.push(ROUTING.sessionTimeout)
      })
      .catch(() => {})
    return
  }
  const time = new Date(millisecondsLeft)
  const hours = time.getUTCHours()
  const minutes = time.getUTCMinutes()
  const seconds = time.getUTCSeconds()

  hoursLeft.value = twoDigits(hours)
  minutesLeft.value = twoDigits(minutes)
  secondsLeft.value = twoDigits(seconds)
  timeoutHandler = setTimeout(updateTimer, 1000)

  function twoDigits(number) {
    return number <= 9 ? '0' + number : number + ''
  }
}

function setSessionRemainingTime(sessionRemainingTime) {
  isTimerSet.value = true
  isAnyTimeLeft.value = sessionRemainingTime > 0
  if (isAnyTimeLeft.value) {
    countdown(sessionRemainingTime)
  }
}

if (paymentData.value.sessionRemainingTime) {
  setSessionRemainingTime(paymentData.value.sessionRemainingTime)
} else {
  store.dispatch('getSessionRemainingTime').then((sessionRemainingTime) => {
    setSessionRemainingTime(sessionRemainingTime)
  })
}

defineExpose({ refresh })
</script>
